export enum Module {
	czMaxPrice = 'czMaxPrice',
	czReimbursement = 'czReimbursement',
	aeMaxPrice = 'aeMaxPrice',
	siMaxPrice = 'siMaxPrice',
	hrMaxPrice = 'hrMaxPrice',
	bgMaxPrice = 'bgMaxPrice',
	roMaxPrice = 'roMaxPrice',
	caLabeling = 'caLabeling',
	skMaxPrice = 'skMaxPrice',
	ltMaxPrice = 'ltMaxPrice',
}
